import { motion } from "framer-motion";

export default function Marquee({ text, dark = false }) {
  const unit = ` ${text} `;
  const chunk = Array.from({ length: 6 }).map(() => unit).join("·");
  return (
    <div
      className={`relative overflow-hidden py-6 border-y ${dark ? "bg-ink border-white/10" : "bg-paper border-black/10"}`}
      data-testid="marquee"
    >
      <motion.div
        className="inline-flex whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 34, ease: "linear", repeat: Infinity }}
        data-testid="marquee-track"
      >
        <span className={`font-display italic text-5xl sm:text-7xl pr-8 ${dark ? "text-white" : "text-ink"}`}>
          {chunk}
        </span>
        <span className={`font-display italic text-5xl sm:text-7xl pr-8 ${dark ? "text-white" : "text-ink"}`} aria-hidden="true">
          {chunk}
        </span>
      </motion.div>
    </div>
  );
}
